import { render, staticRenderFns } from "./DispatchPopup.vue?vue&type=template&id=64790b66"
import script from "./DispatchPopup.vue?vue&type=script&lang=js"
export * from "./DispatchPopup.vue?vue&type=script&lang=js"
import style0 from "./DispatchPopup.vue?vue&type=style&index=0&id=64790b66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports